import script from "./MyBracket.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyBracket.vue?vue&type=script&setup=true&lang=ts"

import "./MyBracket.vue?vue&type=style&index=0&id=b1160366&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1160366"]])

export default __exports__